module.exports = __webpack_public_path__ + "img/17-min.d8c40d86.jpg";